import {routes} from './painel.routes';
import PainelListController from "./directory/directory.controller";
import PainelService from "./painel.service";
import PainelDetailsController from "./details/details.controller";

export default angular.module('app.painel', [])
  .config(routes)
  .controller('PainelListController', PainelListController)
  .service('PainelService', PainelService)
  .controller('PainelDetailsController', PainelDetailsController)
  .name;
